export default __webpack_public_path__ + "static/media/hmd_m2.44528a77.png";